<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card>
      <v-card-title>แบบฟอร์มรายงานการดำเนินการ</v-card-title>
      <v-card-text>
        <v-subheader class="px-0">เลือกวันที่ดำเนินการ</v-subheader>
        <v-row>
          <v-date-picker locale="th" class="elevation-1 mb-5" v-model="form.operation_date" full-width></v-date-picker>
        </v-row>
        <v-row>
          <v-textarea outlined dense v-model="form.short_description" label="การดำเนินการแบบย่อ(จะแสดงให้บุคลากรเห็นเป็นสาธารณะ)"></v-textarea>
        </v-row>
        <v-row>
          <v-textarea outlined dense v-model="form.description" label="การดำเนินการ"></v-textarea>
        </v-row>
        <v-row>
          <v-textarea outlined dense v-model="form.reference" label="อ้างอิง"></v-textarea>
        </v-row>
        <v-row>
          <v-text-field outlined dense v-model="form.note" label="หมายเหตุ"></v-text-field>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="success" @click="submit">บันทึก</v-btn>
        <v-btn color="error" @click="close_dialog">ปิด</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [
    'dialog',
    'form'
  ],
  methods: {
    submit() {
      this.$emit('submit', this.form);
    },
    close_dialog() {
      this.$emit('update:dialog', false);
    }
  }
}
</script>